import React from 'react';

const appLogo = `${process.env.PUBLIC_URL}/gym.svg`;

function BrandHeader({ title, actions = null }) {
  return (
    <div className="relative overflow-hidden bg-slate-950 px-6 py-7 sm:px-8">
      <div className="classes-ambient" aria-hidden="true">
        <span className="classes-ambient__beam classes-ambient__beam--cyan"></span>
        <span className="classes-ambient__beam classes-ambient__beam--pink"></span>
      </div>
      <div className="relative z-10 flex flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
        <div className="flex items-center gap-4">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0_14px_35px_rgba(0,0,0,0.22)]">
            <img src={appLogo} alt="Arboxer" className="h-11 w-11 object-contain" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-cyan-200">Arboxer</p>
            <h2 className="text-2xl font-black tracking-tight text-white sm:text-3xl">{title}</h2>
          </div>
        </div>
        {actions && <div className="flex shrink-0 items-center">{actions}</div>}
      </div>
    </div>
  );
}

export default BrandHeader;
